import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import styleHelper from './../../../helpers/style';
import Spinner from './../../Spinner.jsx';


class SmallVideoCard extends React.Component {
  constructor(props) {
    super(props);

    // used by React as the component name
    this.displayName = 'SmallVideoCard';

    // random unique id for video element
    this.randomId = (0 | Math.random() * 9e6).toString(36);
  }


  /**
   * Called when component mounts to DOM
   * @returns {undefined} undefined
   */
  componentDidMount() {
    this.node = ReactDOM.findDOMNode(this);
    this.videoElement =
      document.getElementsByClassName('vc-' + this.randomId)[0];

    if (this.videoElement) {
      this.videoElement.addEventListener('webkitendfullscreen', () => {
        setTimeout(() => {
          window.scrollTo(0, 0);
          this.forceUpdate();
        }, 300);
      });
    }
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    const data = this.props.data;
    const state = this.props.smallCardFrameworkState;
    const active = (state.currentCardIteration + 1 === data.order);
    let videoStyle = {};

    if (this.node) {
      videoStyle = styleHelper.getSizeToCover(
        data.size.width,
        data.size.height,
        this.node.offsetWidth,
        this.node.offsetHeight
      );
    }

    const videoWrapperStyle = {
      backgroundImage: 'url(' + this.props.data.coverPath + ')',
    };
    const activeClass = active ? ' active' : '';
    const videoClass = 'video-container vc-' + this.randomId;
    const className = 'card component-small-video-card' + activeClass;

    return (
      <section
        className={className}
        style={this.props.style}
      >
        <div
          className='video-wrapper'
          style={videoWrapperStyle}
        >
          <video
            className={videoClass}
            width='100%'
            height='100%'
            controls
            style={videoStyle}
          >
            <source src={data.largePath} type='video/mp4' />
            <source src={data.secondaryLargePath} type='video/webm' />
            Your browser does not support the video tag.
          </video>
        </div>
      </section>
    );
  }
}


/**
 * Expected propTypes
 * @prop {Object} data - An array of card React components
 * @prop {Function} dispatch - A Redux function to dispatch events
 * @prop {Number} iteration - The iteration of the component
 * @prop {Object} mediaLabCardFrameworkState - The state of the
 * container component
 * @prop {Boolean} showImageForUnsupportedAutoplay - If an image should be shown
 * if autoplaying video is not supported
 * @prop {Object} smallCardFrameworkState - The state of the
 * SmallCardFramework component
 * @prop {Object} style - A style object
 */
SmallVideoCard.propTypes = {
  data: React.PropTypes.object.isRequired,
  dispatch: React.PropTypes.func,
  iteration: React.PropTypes.number.isRequired,
  mediaLabCardFrameworkState: React.PropTypes.object.isRequired,
  showImageForUnsupportedAutoplay: React.PropTypes.bool,
  smallCardFrameworkState: React.PropTypes.object.isRequired,
  style: React.PropTypes.object,
};


export default connect(({ mediaLabCardFrameworkState, smallCardFrameworkState }) =>
  ({ mediaLabCardFrameworkState, smallCardFrameworkState }))(SmallVideoCard);



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/cards/small/SmallVideoCard.jsx
 **/